import { rem } from "../../framework/theme/util/misc.js";
import { Box } from "../mantine-passthroughs/index.js";
import "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/icon-tile/IconTile.tsx
const tileSize = {
	xs: rem("32px"),
	sm: rem("40px"),
	md: rem("48px"),
	lg: rem("56px")
};
const getTileRadius = (shape, size) => {
	switch (shape) {
		case "circle": return "50%";
		case "square": return "0";
		case "squircle": return `var(--mantine-radius-${size})`;
	}
};
const IconTile = ({ Icon, color = "primary", shape = "circle", size = "md", alt, dataTestId, "data-testid": testId = dataTestId ?? "icon-tile" }) => {
	return /* @__PURE__ */ jsx(Box, {
		"data-testid": testId,
		display: "flex",
		bg: `var(--mantine-color-${color}-background-hover)`,
		h: tileSize[size],
		w: tileSize[size],
		"aria-label": alt,
		style: {
			alignItems: "center",
			borderRadius: getTileRadius(shape, size),
			justifyContent: "center",
			pointerEvents: "none"
		},
		children: /* @__PURE__ */ jsx(Icon, {
			color,
			width: "65%",
			height: "65%"
		})
	});
};

//#endregion
export { IconTile };